import Component from './text-field-wrapper.component'

export default Component
